module.exports = __webpack_public_path__ + "static/img/UC3880-HD.f6742cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/UC3880-HD.jpg
// module id = 6+43
// module chunks = 52